import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { markSplashAsSeen, getCurrentSplashStep, setCurrentSplashStep } from '../../utils/util';
import CustomButton from '../../components/CustomButton';
import './SplashScreen.css';

const SplashScreen = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();

  // Splash screen data for each step
  const splashData = [
    {
      title: 'Energy is not\n just power.',
      subtitle: "It's comfort, savings,\nand a cleaner planet.",
    },
    {
      title: 'Control your\ndevices',
      subtitle: 'See exactly how much\nenergy your appliances use',
    },
    {
      title: 'Save at the\n right time',
      subtitle: 'Get smart tips on when\nenergy is cheaper and cleaner.',
    },
  ];

  useEffect(() => {
    const savedStep = getCurrentSplashStep();
    setCurrentStep(savedStep);
  }, []);

  const handleContinue = () => {
    if (currentStep < 3) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      setCurrentSplashStep(nextStep);
    } else {
      markSplashAsSeen();
      navigate('/login');
    }
  };

  const currentData = splashData[currentStep - 1];

  return (
    <div className={`splash-screen step-${currentStep}`}>
      <div className="responsive-container">
        <div className="splash-progress">
          {[1, 2, 3].map((step) => (
            <div key={step} className={`splash-progress-line ${step <= currentStep ? 'active' : 'inactive'}`} />
          ))}
        </div>

        {/* Main content */}
        <div className="splash-content">
          <div className="splash-text-content">
            <h1 className="splash-title">{currentData.title}</h1>
            <p className="splash-subtitle">{currentData.subtitle}</p>
          </div>

          <CustomButton onClick={handleContinue} variant="primary" size="medium">
            {currentStep === 3 ? 'Get Started' : 'Continue'}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
